import { ArrowLeftOutlined } from '@ant-design/icons'
import { useAuth } from '@utils/auth/Auth'
import { login } from '@utils/auth/requests'
import { Alert, Button, Space, Spin, Typography } from 'antd'
import { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'

const { Text } = Typography

const HandleMagicLink = () => {
  const navigate = useNavigate()
  const { saveAuth, setCurrentUser, setIsLogged } = useAuth()
  const [searchParams, _] = useSearchParams()

  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [error, setError] = useState<string | undefined>(undefined)

  useEffect(() => {
    setIsLoading(true)
    login(
      searchParams.get('expires'),
      searchParams.get('token'),
      searchParams.get('returnTo'),
      searchParams.get('signature')
    )
      .then((data) => {
        saveAuth(data.data.token)
        setCurrentUser(data.data.user)
        setIsLogged(true)
      })
      .catch(() => {
        setError('Erreur - Lien invalide ou déjà utilisé')
        setIsLoading(false)
      })
  }, [])

  return (
    <>
      {(error === undefined || isLoading) && (
        <Space vertical align="center" style={{ width: '100%' }}>
          <Spin />
          <Text>Chargement ...</Text>
        </Space>
      )}
      <div style={{ textAlign: 'center', marginTop: 10 }}>
        {error && (
          <Space vertical align="center" style={{ width: '100%' }}>
            <Alert style={{ marginBottom: 25 }} title={error} type="error" />
            <Button
              className="w-full"
              type="text"
              onClick={() => navigate('/')}
            >
              <ArrowLeftOutlined /> Retour à la connexion
            </Button>
          </Space>
        )}
      </div>
    </>
  )
}

export default HandleMagicLink
